import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchTimeout } from "../../components/Common";
import { API_BASE } from "../../AppConfig";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import CreateNewFolderIcon from "@material-ui/icons/CreateNewFolder";
import { CircularProgress } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import { blue } from "@material-ui/core/colors";
import {
    UPDATE_QUOTE_PARAMETERS,
    updateJobState,
    updateJobParameter,
    addNote,
    updateJobHistory,
} from "../../redux_store/jobState";
import { SHOW_DESIGNER_MESSAGE } from "../../redux_store/appState";
import BSL_Button from "../../components/BSL_Button";
import { addNewHistoryLine } from "../../helper/Helper";
import * as BSL_Common from "../../components/BSL_CommonControls";
import { DStateActive } from "../../redux_store/appStateHelper";
import { addStatusTrackingEntry } from "../../helper/Helper";

const { convertJobStateToIni } = require("../../components/Common_Conversions");

const useStyles = makeStyles({
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    container: {
        padding: "10px",
    },
    gridRow: {
        display: "grid",
        gridTemplateColumns: "110px auto",
    },
});

function sortedList(material_list) {
    const list = [material_list.items];
    const dictionary = [
        "STEEL ROOFING",
        "POLYCARBONATE ROOFING",
        "FIBREGLASS ROOFING",
        "BACK CHANNEL",
        "GUTTERS & ACCESSORIES",
        "DOWNPIPES & ACCESSORIES",
        "FLASHING",
        "BEAMS",
        "POSTS",
        "POSTS & ACCESSORIES",
        "BRACKETS",
        "CONNECTORS",
        "HARDWARE",
        "MISCELLANEOUS ITEMS",
    ];

    const tempMatList = [];
    for (let i = 0; i < dictionary.length; i++) {
        for (let iter2 = 0; iter2 < Object.keys(list[0]).length; iter2++) {
            if (String(list[0][iter2].Category).toUpperCase() == dictionary[i].toUpperCase()) {
                tempMatList.push(list[0][iter2]);
            }
        }
    }

    // KC added, if item does not match a category, add it at the end...
    for (let iter2 = 0; iter2 < Object.keys(list[0]).length; iter2++) {
        if (!dictionary.includes(String(list[0][iter2].Category).toUpperCase())) {
            tempMatList.push(list[0][iter2]);
        }
    }

    return tempMatList;
}

export default function Dialog_SendToLyves(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { onClose, selectedValue, open } = props;
    const logged_user_code = useSelector((state) => state.app.logged_user_code);
    const user = useSelector((state) => state.app.user);
    const app = useSelector((state) => state.app);
    const job = useSelector((state) => state.job);
    const config = useSelector((state) => state.config);
    const [ordering, setOrdering] = React.useState(false);
    const [allowLyves, setAllowLyves] = React.useState(false);
    const D365_State_Active = DStateActive({ config });
    const isDebugMode = window.debug || window.test;
    const isUserPrivileged = D365_State_Active || window.location.href.includes("sit.");
    const deliveryDate = job?.QuoteParameters?.DeliveryDate;

    let has_BOM_data = job?.QuoteParameters?.BOM?.SystemList?.total_price;
    let material_list = job?.QuoteParameters?.BOM?.OrderList;

    if (!material_list || !material_list?.items) {
        material_list = job?.QuoteParameters?.BOM?.SystemList;
    }

    // Check for TBA colours and get the actual item
    let TBAColour = job?.QuoteParameters?.BOM?.OrderList?.items
        ? job.QuoteParameters.BOM.OrderList.items.find((item) => item?.Colour === "TBA")
        : job?.QuoteParameters?.BOM?.SystemList?.items
        ? job.QuoteParameters.BOM.SystemList.items.find((item) => item?.Colour === "TBA")
        : null;

    const pricingTier =
        job?.Customer?.DistLevel || job?.Distributor?.LYVESAccount || app?.user?.BusinessDetails?.LYVESAccount || "";

    const handleClose = () => {
        onClose(selectedValue);
        setAllowLyves(false);
    };

    React.useEffect(() => {
        if (open && !has_BOM_data) {
            dispatch({
                type: SHOW_DESIGNER_MESSAGE,
                message: "There appears to be no BOM data for this job. You will not be able to order this job.",
            });
        }
    }, [open]);

    React.useEffect(() => {
        if (open && !job?.QuoteParameters?.DeliveryDate) {
            dispatch({
                type: SHOW_DESIGNER_MESSAGE,
                message:
                    "There appears to be no Delivery Date Selected for this job. You will not be able to order this job.",
            });
        }
    }, [open]);

    React.useEffect(() => {
        if (open && TBAColour) {
            dispatch({
                type: SHOW_DESIGNER_MESSAGE,
                message: { message: `Can not submit order with TBA colours. Item: ${TBAColour.Code}`, type: "error" },
            });
        }
    }, [open]);

    const getCSV = (type = "CSV", sit = false) => {
        if (ordering || !job) {
            return;
        }

        setOrdering(type);

        let job_ini = convertJobStateToIni(job, app, "", config);
        let csv_url = API_BASE() + "lyves/" + btoa(logged_user_code) + "/" + type;
        let job_id = job?.id;
        let business_code = job?.BusinessCode;
        let history = job?.History || [];
        let newHistory = addNewHistoryLine({
            jobState: { history },
            historyLine: { "GS1 Update": type },
        });

        if (sit) {
            csv_url = API_BASE() + "SITLyves/" + btoa(logged_user_code) + "/" + type;
        }

        if (newHistory?.length > 0) {
            history.push(newHistory[0]);
        }

        material_list.items = sortedList(material_list);

        dispatch(updateJobHistory({ business_code, job_id, new_history: history }));

        return fetchTimeout(
            csv_url,
            {
                method: "POST",
                body: JSON.stringify({
                    job_raw: job,
                    job: job_ini,
                    order_list: material_list,
                    user: user,
                    USE_EPRICE: window.USE_EPRICE,
                }),
            },
            material_list?.items?.length > 500 ? 90000 : 45000
        )
            .then(async (response) => {
                setOrdering(false);
                if (response.status === 422) {
                } else if (response.status >= 200 && response.status < 300) {
                    let response_text = await response.text();

                    if (type === "CSV" || type === "DownloadGS1" || window.debug) {
                        var element = document.createElement("a");
                        element.setAttribute(
                            "href",
                            "data:text/plain;charset=utf-8," + encodeURIComponent(response_text)
                        );
                        element.setAttribute("download", job.id + "_LYVES." + (type === "CSV" ? "CSV" : "GS1"));
                        element.style.display = "none";
                        document.body.appendChild(element);
                        element.click();
                        document.body.removeChild(element);

                        dispatch(
                            addNote(
                                true,
                                user,
                                "Order Accepted and Processed Manually (" + (type === "CSV" ? "CSV" : "GS1") + ")"
                            )
                        );

                        dispatch({
                            type: SHOW_DESIGNER_MESSAGE,
                            message: "Downloading a GS1 or CSV file will not update the job status",
                        });
                    } else if (type === "GS1") {
                        const updatedStatusTracking = addStatusTrackingEntry("Ordered", job?.StatusTracking);
                        const updatedOrderStatusTracking = addStatusTrackingEntry("Accepted", job?.OrderStatusTracking);

                        dispatch(
                            updateJobParameter(null, {
                                Status: "Ordered",
                                StatusTracking: updatedStatusTracking,
                                OrderStatus: "Accepted",
                                OrderStatusTracking: updatedOrderStatusTracking,
                            })
                        );

                        dispatch({
                            type: SHOW_DESIGNER_MESSAGE,
                            message: {
                                type: "Success",
                                message: response_text,
                            },
                        });

                        dispatch(addNote(true, user, "Order Accepted and Processed (GS1)"));
                    }
                    handleClose();
                } else {
                    setOrdering(false);
                    let response_text = await response.text();

                    dispatch({
                        type: SHOW_DESIGNER_MESSAGE,
                        message: response_text,
                    });
                }
            })
            .catch((e) => {
                setOrdering(false);
            });
    };

    const handleDateChange = (date) => {
        const formattedDate = date ? date.toISOString().split("T")[0] : null;
        dispatch(updateJobState(UPDATE_QUOTE_PARAMETERS, "DeliveryDate", formattedDate));
    };

    const disableConditions = () => ordering || !has_BOM_data || !deliveryDate || TBAColour;

    const renderListItem = (label, type, highlight = false, manual = false) => (
        <ListItem
            button
            disabled={disableConditions()}
            onClick={() => getCSV(type, manual)}
            style={{ backgroundColor: highlight ? "oldlace" : "" }}
            title={highlight ? "Lyves is our older system, transitioning to D365." : ""}
        >
            <ListItemAvatar>
                <Avatar className={classes.avatar}>
                    {ordering === type ? <CircularProgress style={{ zIndex: 1 }} /> : null}
                    <div style={{ position: "absolute" }}>
                        <CreateNewFolderIcon />
                    </div>
                </Avatar>
            </ListItemAvatar>
            <ListItemText primary={label} />
        </ListItem>
    );

    if (["ACCEPTED"].includes(job?.OrderStatus.toUpperCase()) && !allowLyves) {
        return (
            open && (
                <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
                    <DialogTitle id="simple-dialog-title">
                        Job has already been sent to Lyves, this will result in additional order for same job in Lyves,
                        do you want to continue?
                    </DialogTitle>
                    <br />
                    <List style={{ display: "flex", justifyContent: "center" }}>
                        <BSL_Button secondary style={{ marginRight: "10px" }} onClick={handleClose}>
                            Cancel
                        </BSL_Button>
                        <BSL_Button style={{ marginLeft: "10px" }} onClick={() => setAllowLyves(true)}>
                            OK
                        </BSL_Button>
                    </List>
                </Dialog>
            )
        );
    } else
        return (
            <Dialog onClose={handleClose} aria-labelledby="job-dialog-title" open={open}>
                <BSL_Common.SectionContainer className={classes.container}>
                    <DialogTitle id="job-dialog-title">
                        Send Job To {D365_State_Active ? "ERP" : "Lyves"}{" "}
                        {isDebugMode && `(${window.test ? "TEST" : "DEBUG"})`}
                    </DialogTitle>

                    <div className={classes.gridRowContainer}>
                        <div className={classes.gridRow}>
                            <div className={classes.label}>Retained value:</div>
                            <div className={classes.value}>${material_list?.total_retained_price?.toFixed(2) || 0}</div>
                        </div>
                        <div className={classes.gridRow}>
                            <div className={classes.label}>Pricing tier:</div>
                            <div className={classes.value}>{pricingTier}</div>
                        </div>
                    </div>

                    <List>
                        <div>Confirm Delivery Date</div>
                        <DatePicker
                            disableForwardDays={0}
                            disableToolbar
                            variant="inline"
                            value={deliveryDate}
                            onChange={handleDateChange}
                        />

                        {isUserPrivileged && renderListItem("Send Job Directly To ERP (GS1)", "GS1", false, true)}

                        {isUserPrivileged &&
                            renderListItem("Download CSV File (manual processing)", "CSV", false, true)}
                        {isUserPrivileged && renderListItem("Download GS1 File", "DownloadGS1", false, true)}
                        {user?.Role >= 90 &&
                            renderListItem("Send Job Directly To Lyves (GS1)", "GS1", D365_State_Active)}
                        {user?.Role >= 90 &&
                            renderListItem("Download Lyves CSV File (manual processing)", "CSV", D365_State_Active)}

                        {user?.Role >= 90 &&
                            renderListItem("Download Lyves GS1 File", "DownloadGS1", D365_State_Active)}
                    </List>
                </BSL_Common.SectionContainer>
            </Dialog>
        );
}

Dialog_SendToLyves.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};
